import { Box, Typography, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import StyledButton from '../Common/StyledButton';
import StyledBackButton from '../Common/StyledBackButton';
import { SUBSCRIPTION_PLANS } from '../../utils/routes';
import { useAppSelector } from '../../redux/hooks';
import { formatPlanName } from '../../utils/paymentUtills';

interface IClientDeleteModalProps {
  handleDismiss: () => void;
}

const StyledTypography = styled(Typography)({
  '& span': {
    background:
      'var(--Alert-Sunset-Orange, linear-gradient(175deg, #FF9A9A -9.81%, #FF5858 96.32%))',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
});

function SubscriptionPlanWarningModal({ handleDismiss }: IClientDeleteModalProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleUpgrade = () => {
    navigate(SUBSCRIPTION_PLANS);
  };
  const { subscriptionPlanStatus, isPrincipalCoach } = useAppSelector((state) => state.coach.coach);
  let plan = '';

  if (subscriptionPlanStatus?.currentPlan) {
    plan = formatPlanName(subscriptionPlanStatus?.currentPlan);
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      gap="36px"
      borderRadius="10px"
    >
      <Box
        p="32px"
        width="100%"
        sx={{
          borderTopLeftRadius: '10px',
          borderTopRightRadius: '10px',
          background:
            'linear-gradient(175.46deg, rgba(255, 154, 154, 0.2) -9.81%, rgba(255, 88, 88, 0.2) 96.32%)',
        }}
      >
        <Box display="flex" justifyContent="center" alignItems="center">
          <img src="/assets/icons/shield-warning-red-bold.svg" alt="shield" width={70} />
        </Box>
        <Box display="flex" flexDirection="column" gap={2} p={3}>
          <StyledTypography variant="title2Bold" textAlign="center">
            <span>{t('subscriptionPlan.limitReached', { plan })}</span>
          </StyledTypography>
        </Box>
      </Box>
      <Box display="flex" flexDirection="column" gap={1} px={5} justifyContent="center">
        <Typography variant="bodyRegular" color="primary" textAlign="center">
          {t('subscriptionPlan.limitReachedDesc', { plan })}
        </Typography>
      </Box>
      <Box display="flex" gap="12px" width="100%" p="32px" flexDirection="column">
        {isPrincipalCoach && (
          <StyledButton onClick={handleUpgrade}>{t('subscriptionPlan.upgrade')}</StyledButton>
        )}
        <StyledBackButton variant="outlined" fullWidth onClick={handleDismiss}>
          <span>{t('clientTable.deleteClient.dismiss')}</span>
        </StyledBackButton>
      </Box>
    </Box>
  );
}

export default SubscriptionPlanWarningModal;
